// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { AddressMode } from "./address-mode";
import { Decode, unionToDecode, unionListToDecode } from "./decode";
import { EnumMapRule, EnumMapRuleT, verifyEnumMapRule } from "./enum-map-rule";
import { FlagRule, FlagRuleT, verifyFlagRule } from "./flag-rule";
import { IgnoreRule, IgnoreRuleT, verifyIgnoreRule } from "./ignore-rule";
import { Key, KeyT } from "./key";
import { RecordRule, RecordRuleT, verifyRecordRule } from "./record-rule";
import { Rule, unionToRule, unionListToRule } from "./rule";
import { ScalarDecode, ScalarDecodeT, verifyScalarDecode } from "./scalar-decode";
import { StructDecode, StructDecodeT, verifyStructDecode } from "./struct-decode";
import { TextDecode, TextDecodeT, verifyTextDecode } from "./text-decode";
import { TransformDecode, TransformDecodeT, verifyTransformDecode } from "./transform-decode";
import { TransformRule, TransformRuleT, verifyTransformRule } from "./transform-rule";
import { ValuedRule, ValuedRuleT, verifyValuedRule } from "./valued-rule";

/**
 * An override of one IDL entry's translation, matched by key. An absent
 * `decode` is derived from the IDL type.
 */
export class EntryOverride implements flatbuffers.IUnpackableObject<EntryOverrideT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): EntryOverride {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsEntryOverride(bb: flatbuffers.ByteBuffer, obj?: EntryOverride): EntryOverride {
    return (obj || new EntryOverride()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsEntryOverride(
    bb: flatbuffers.ByteBuffer,
    obj?: EntryOverride,
  ): EntryOverride {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new EntryOverride()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  key(obj?: Key): Key | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? (obj || new Key()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  decodeType(): Decode {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Decode.NONE;
  }

  decode<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  ruleType(): Rule {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Rule.NONE;
  }

  rule<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  address(): AddressMode {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : AddressMode.Unspecified;
  }

  addressField(): string | null;
  addressField(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  addressField(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  note(): string | null;
  note(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  note(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startEntryOverride(builder: flatbuffers.Builder) {
    builder.startObject(8);
  }

  static addKey(builder: flatbuffers.Builder, keyOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, keyOffset, 0);
  }

  static addDecodeType(builder: flatbuffers.Builder, decodeType: Decode) {
    builder.addFieldInt8(1, decodeType, Decode.NONE);
  }

  static addDecode(builder: flatbuffers.Builder, decodeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, decodeOffset, 0);
  }

  static addRuleType(builder: flatbuffers.Builder, ruleType: Rule) {
    builder.addFieldInt8(3, ruleType, Rule.NONE);
  }

  static addRule(builder: flatbuffers.Builder, ruleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, ruleOffset, 0);
  }

  static addAddress(builder: flatbuffers.Builder, address: AddressMode) {
    builder.addFieldInt8(5, address, AddressMode.Unspecified);
  }

  static addAddressField(builder: flatbuffers.Builder, addressFieldOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, addressFieldOffset, 0);
  }

  static addNote(builder: flatbuffers.Builder, noteOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, noteOffset, 0);
  }

  static endEntryOverride(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // key
    builder.requiredField(offset, 12); // rule
    return offset;
  }

  static createEntryOverride(
    builder: flatbuffers.Builder,
    keyOffset: flatbuffers.Offset,
    decodeType: Decode,
    decodeOffset: flatbuffers.Offset,
    ruleType: Rule,
    ruleOffset: flatbuffers.Offset,
    address: AddressMode,
    addressFieldOffset: flatbuffers.Offset,
    noteOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    EntryOverride.startEntryOverride(builder);
    EntryOverride.addKey(builder, keyOffset);
    EntryOverride.addDecodeType(builder, decodeType);
    EntryOverride.addDecode(builder, decodeOffset);
    EntryOverride.addRuleType(builder, ruleType);
    EntryOverride.addRule(builder, ruleOffset);
    EntryOverride.addAddress(builder, address);
    EntryOverride.addAddressField(builder, addressFieldOffset);
    EntryOverride.addNote(builder, noteOffset);
    return EntryOverride.endEntryOverride(builder);
  }

  unpack(): EntryOverrideT {
    return new EntryOverrideT(
      this.key() !== null ? this.key()!.unpack() : null,
      this.decodeType(),
      (() => {
        const temp = unionToDecode(this.decodeType(), this.decode.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.ruleType(),
      (() => {
        const temp = unionToRule(this.ruleType(), this.rule.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.address(),
      this.addressField(),
      this.note(),
    );
  }

  unpackTo(_o: EntryOverrideT): void {
    _o.key = this.key() !== null ? this.key()!.unpack() : null;
    _o.decodeType = this.decodeType();
    _o.decode = (() => {
      const temp = unionToDecode(this.decodeType(), this.decode.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.ruleType = this.ruleType();
    _o.rule = (() => {
      const temp = unionToRule(this.ruleType(), this.rule.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.address = this.address();
    _o.addressField = this.addressField();
    _o.note = this.note();
  }

  unpackFields(...fields: string[]): EntryOverrideT {
    const t = new EntryOverrideT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("key")) {
      t.key = this.key() !== null ? this.key()!.unpack() : null;
    }
    if (fieldSet.has("decode_type")) {
      t.decodeType = this.decodeType();
    }
    if (fieldSet.has("decode")) {
      t.decode = (() => {
        const temp = unionToDecode(this.decodeType(), this.decode.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("rule_type")) {
      t.ruleType = this.ruleType();
    }
    if (fieldSet.has("rule")) {
      t.rule = (() => {
        const temp = unionToRule(this.ruleType(), this.rule.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("address")) {
      t.address = this.address();
    }
    if (fieldSet.has("address_field")) {
      t.addressField = this.addressField();
    }
    if (fieldSet.has("note")) {
      t.note = this.note();
    }
    return t;
  }
}

export class EntryOverrideT implements flatbuffers.IGeneratedObject {
  constructor(
    public key: KeyT | null = null,
    public decodeType: Decode = Decode.NONE,
    public decode: ScalarDecodeT | StructDecodeT | TextDecodeT | TransformDecodeT | null = null,
    public ruleType: Rule = Rule.NONE,
    public rule:
      | EnumMapRuleT
      | FlagRuleT
      | IgnoreRuleT
      | RecordRuleT
      | TransformRuleT
      | ValuedRuleT
      | null = null,
    public address: AddressMode = AddressMode.Unspecified,
    public addressField: string | Uint8Array | null = null,
    public note: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.key === null || this.key === undefined) {
      throw new Error('Required field "key" is not set');
    }
    if (this.rule === null || this.rule === undefined) {
      throw new Error('Required field "rule" is not set');
    }
    const decode = builder.createObjectOffset(this.decode);
    const rule = builder.createObjectOffset(this.rule);
    const addressField = this.addressField !== null ? builder.createString(this.addressField!) : 0;
    const note = this.note !== null ? builder.createString(this.note!) : 0;

    return EntryOverride.createEntryOverride(
      builder,
      this.key !== null ? this.key!.pack(builder) : 0,
      this.decodeType,
      decode,
      this.ruleType,
      rule,
      this.address,
      addressField,
      note,
    );
  }

  clone(): EntryOverrideT {
    const obj = new EntryOverrideT();
    obj.key = this.key !== null ? this.key!.clone() : null;
    obj.decodeType = this.decodeType;
    obj.decode =
      this.decode !== null && typeof (this.decode as any).clone === "function"
        ? (this.decode as any).clone()
        : this.decode;
    obj.ruleType = this.ruleType;
    obj.rule =
      this.rule !== null && typeof (this.rule as any).clone === "function"
        ? (this.rule as any).clone()
        : this.rule;
    obj.address = this.address;
    obj.addressField = this.addressField;
    obj.note = this.note;
    return obj;
  }

  equals(other: EntryOverrideT): boolean {
    if (this.key !== null && other.key !== null) {
      if (!this.key!.equals(other.key!)) return false;
    } else if (this.key !== other.key) return false;
    if (this.decodeType !== other.decodeType) return false;
    if (this.decode !== null && other.decode !== null) {
      if (typeof (this.decode as any).equals === "function") {
        if (!(this.decode as any).equals(other.decode)) return false;
      } else if (this.decode !== other.decode) return false;
    } else if (this.decode !== other.decode) return false;
    if (this.ruleType !== other.ruleType) return false;
    if (this.rule !== null && other.rule !== null) {
      if (typeof (this.rule as any).equals === "function") {
        if (!(this.rule as any).equals(other.rule)) return false;
      } else if (this.rule !== other.rule) return false;
    } else if (this.rule !== other.rule) return false;
    if (this.address !== other.address) return false;
    if (this.addressField !== other.addressField) return false;
    if (this.note !== other.note) return false;
    return true;
  }
}

export function verifyEntryOverride(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 12);
    verifier.checkRequiredField(tablePos, 4, "key");
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkUnionConsistency(tablePos, 6, 8, "decode");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 6);
        switch (uType) {
          case 1: // ScalarDecode
            {
              const o = verifier.readInt32(pos);
              verifyScalarDecode(verifier, pos + o);
            }
            break;
          case 2: // StructDecode
            {
              const o = verifier.readInt32(pos);
              verifyStructDecode(verifier, pos + o);
            }
            break;
          case 3: // TextDecode
            {
              const o = verifier.readInt32(pos);
              verifyTextDecode(verifier, pos + o);
            }
            break;
          case 4: // TransformDecode
            {
              const o = verifier.readInt32(pos);
              verifyTransformDecode(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkUnionConsistency(tablePos, 10, 12, "rule");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 10);
        switch (uType) {
          case 1: // IgnoreRule
            {
              const o = verifier.readInt32(pos);
              verifyIgnoreRule(verifier, pos + o);
            }
            break;
          case 2: // FlagRule
            {
              const o = verifier.readInt32(pos);
              verifyFlagRule(verifier, pos + o);
            }
            break;
          case 3: // ValuedRule
            {
              const o = verifier.readInt32(pos);
              verifyValuedRule(verifier, pos + o);
            }
            break;
          case 4: // EnumMapRule
            {
              const o = verifier.readInt32(pos);
              verifyEnumMapRule(verifier, pos + o);
            }
            break;
          case 5: // RecordRule
            {
              const o = verifier.readInt32(pos);
              verifyRecordRule(verifier, pos + o);
            }
            break;
          case 6: // TransformRule
            {
              const o = verifier.readInt32(pos);
              verifyTransformRule(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 12, "rule");
    verifier.checkScalarField(tablePos, 14, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
